module.exports = __webpack_public_path__ + "static/media/section1-bg.483f853c.png";